import { showLoader, hideLoader } from '../../actions/shared/loader';
import { showError, setErrorObject } from '../../actions/shared/HTTPError';
import fetcher from '../../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  getFetcherHeader
} from '../../modules/ajio-fetch/utils';
import { tokenReCreateParser } from '../../modules/ajio-fetch/utils';
import { readCookie } from '../../components/common/Cookie.js';
import isNode from '../../modules/ajio-util/isNode.js';
import properties from '../../modules/ajio-util/properties';

const url = properties.getProperty('apiUrl');
const rilwebserviceUrl = '/rilfnlwebservices/v2/rilfnl';


function setAjioWalletData(ajioWalletData = {}) {
  return {
    type: 'SET_AJIOWALLET_DATA',
    ajioWalletData
  };
}

function getAjioWalletDataSuccess() {
  return {
    type: 'GET_AJIOWALLET_DATA_SUCCESS',
    success: true
  };
}

function getAjioWalletDataFail(error) {
  return {
    type: 'GET_AJIOWALLET_DATA_FAIL',
    success: false
  };
}

function setAjioWalletTxnData(ajioWalletTxnData = {}) {
  return {
    type: 'SET_AJIOWALLET_TXN_DATA',
    ajioWalletTxnData
  };
}

function getAjioWalletTxnDataSuccess() {
  return {
    type: 'GET_AJIOWALLET_TXN_DATA_SUCCESS',
    success_txn_data: true
  };
}

function getAjioWalletTxnDataFail(error) {
  return {
    type: 'GET_AJIOWALLET_TXN_DATA_FAIL',
    success_txn_data: false
  };
}

function setAjioWalletEarnData(ajioWalletEarnData = {}) {
  return {
    type: 'SET_AJIOWALLET_EARN_DATA',
    ajioWalletEarnData
  };
}

function setAjioWalletBurnData(ajioWalletBurnData = {}) {
  return {
    type: 'SET_AJIOWALLET_BURN_DATA',
    ajioWalletBurnData
  };
}

function setAjioWalletEarnAmount(ajioWalletEarnData = 0) {
  return {
    type: 'SET_AJIOWALLET_EARN_AMOUNT',
    ajioWalletEarnData
  };
}

function setWalletLandingPageFaqs(ajioWalletFaqs = []) {
  return {
    type: 'SET_AJIOWALLET_FAQS',
    ajioWalletFaqs
  };
}

/*
  function to get the ajio wallet details from API
*/

export function getAjioWalletTxnData(requestObj = {}) {
  let { isRequestOrginIsBrowser = false, request = {} } = requestObj;
  return dispatch => {
    let { pathname = '' } = request;
    let apiEndPoint;
    /**
     * Show loader if the call is triggered from client-side
     */
    let body = {};
    if (isRequestOrginIsBrowser) {
      dispatch(showLoader('ajiowallet-loader'));
    } else {
      let { headers: { host = '' } = {} } = request;
      apiEndPoint = `http://${host}/api/my-account/ajiowallet-txn-data`;
      body = {
        A: request.cookies.A,
        U: request.cookies.U
      };
    }
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify(body),
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(setAjioWalletTxnData(response));
        dispatch(getAjioWalletTxnDataSuccess());
        dispatch(hideLoader('ajiowallet-loader'));
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              getAjioWalletTxnData(requestObj)(dispatch);
            });
          }
          dispatch(getAjioWalletTxnDataFail(error));
          dispatch(setErrorObject(errorObj));
          dispatch(hideLoader('ajiowallet-loader'));
        });
      });
  };
}

export function getAjioWalletEarnData(requestObj = {}, cb) {
  let { isRequestOrginIsBrowser = false, request = {} } = requestObj;
  return dispatch => {
    // if(readCookie("U")=== "anonymous"){
    //     return;
    // }
    if (isNode() && request?.cookies?.U === 'anonymous') {
      return;
    }
    if (!isNode() && readCookie('U') === 'anonymous') {
      return;
    }

    let { pathname = '', device: { client_type = '' } = {} } = request;
    let apiEndPoint;
    /**
     * Show loader if the call is triggered from client-side
     */
    let body = {};
    if (isRequestOrginIsBrowser) {
      apiEndPoint = `/api/my-account/ajiowallet-eligible-earn`;

      dispatch(showLoader('ajiowallet-loader'));
    } else {
      let { headers: { host = '' } = {} } = request;
      apiEndPoint = `http://${host}/api/my-account/ajiowallet-eligible-earn`;
      body = {
        A: request.cookies.A,
        U: request.cookies.U,
        C: request.cookies.C,
        O: request.cookies.O,
        client_type
      };
    }

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify(body),
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(setAjioWalletEarnData(response));
        dispatch(hideLoader('ajiowallet-loader'));

        if (cb) {
          cb();
        }

        return Promise.resolve(response);
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode)
          .then((errorObj = {}) => {
            if (statusCode === 401) {
              return tokenReCreateParser(statusCode, errorObj)
                .then(() => {
                  Promise.resolve(getAjioWalletEarnData(requestObj)(dispatch));
                })
                .catch(err => {
                  dispatch(hideLoader('ajiowallet-loader'));
                  return Promise.reject(err);
                });
            }
            dispatch(hideLoader('ajiowallet-loader'));
            return Promise.reject(errorObj);
          })
          .catch(err => {
            dispatch(hideLoader('ajiowallet-loader'));
            return Promise.reject(err);
          });
      });
  };
}

export function getAjioWalletBurnData(requestObj = {}) {
  let { isRequestOrginIsBrowser = false, request = {} } = requestObj;
  return dispatch => {
    let { pathname = '' } = request;
    let apiEndPoint;
    /**
     * Show loader if the call is triggered from client-side
     */
    let body = {};
    if (isRequestOrginIsBrowser) {
      dispatch(showLoader('ajiowallet-loader'));
    } else {
      let { headers: { host = '' } = {} } = request;
      apiEndPoint = `http://${host}/api/my-account/ajiowallet-eligible-burn`;
      body = {
        A: request.cookies.A,
        U: request.cookies.U,
        C: request.cookies.C,
        O: request.cookies.O
      };
    }

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify(body),
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(setAjioWalletBurnData(response));
        dispatch(hideLoader('ajiowallet-loader'));
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              getAjioWalletBurnData(requestObj)(dispatch);
            });
          }
          dispatch(hideLoader('ajiowallet-loader'));
        });
      });
  };
}

/*
  function to get the address details from API
*/

export function getAjioWalletData(requestObj = {}) {
  let { isRequestOrginIsBrowser = false, request = {} } = requestObj;
  return dispatch => {
    let { pathname = '' } = request;
    let apiEndPoint;
    /**
     * Show loader if the call is triggered from client-side
     */
    let body = {};
    const headerInfo = getFetcherHeader(request);
    if (isRequestOrginIsBrowser) {
      dispatch(showLoader('ajiowallet-loader'));
    } else {
      let { headers: { host = '' } = {} } = request;
      apiEndPoint = `http://${host}/api/my-account/ajiowallet-details`;
      body = {
        A: request.cookies.A,
        U: request.cookies.U
      };
    }

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify(body),
        method: 'POST',
        headers: { 'content-type': 'application/json', ...headerInfo },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        console.log('#### ajio wallet api response actions update', response);
        dispatch({ type: 'SET_AJIOWALLET_DATA_BOTTOMSTRIP', payload: { ajioWalletData : response } });
        dispatch({ type: 'GET_AJIOWALLET_DATA_SUCCESS_BOTTOMSTRIP'});
        dispatch(setAjioWalletData(response));
        dispatch(getAjioWalletDataSuccess());
        dispatch(hideLoader('ajiowallet-loader'));
      })
      .catch(error => {
        console.log('#### ajio wallet api error actions update', error);
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              getAjioWalletData(requestObj)(dispatch);
            });
          }
        dispatch({ type: 'GET_AJIOWALLET_DATA_FAIL_BOTTOMSTRIP'});
          dispatch(getAjioWalletDataFail(error));
          dispatch(setErrorObject(errorObj));
          dispatch(hideLoader('ajiowallet-loader'));
        });
      });
  };
}

export function setAjioEarnAmount(earnAmount) {
  return dispatch => {
    dispatch(setAjioWalletEarnAmount(earnAmount));
  };
}

export function getAjioWalletPageFaqs(requestObj = {}) {
  const { request = {} } = requestObj;
  const headerInfo = getFetcherHeader(request);
  return dispatch => {
    const apiEndPoint = `${url}${rilwebserviceUrl}/referral/questions?pageLabel=ajiowallet`;
    const { A: token = '' } = request.cookies;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'content-type': 'application/json',
          ...headerInfo
        }
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(setWalletLandingPageFaqs(response));
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}
